export default "__VITE_ASSET__H_3cEsj5__"